(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('premium-product-information')) {
    class PremiumProductInformation extends HTMLElement {}
    customElements.define('premium-product-information', PremiumProductInformation)
  }

  document.querySelectorAll('.ppi:not([data-initialized])').forEach((root) => {
    root.dataset.initialized = 'true';
    const variantsNode = root.querySelector('[data-product-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const form = root.querySelector('[data-product-form]');
    const moneyFormat = window.Shopify && Shopify.money_format ? Shopify.money_format : '$0.00';
    const formatMoney = (cents) => {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && Shopify.money_format) return Shopify.formatMoney(cents, moneyFormat);
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD' }).format(cents / 100);
    };

    const thumbs = [...root.querySelectorAll('[data-media-target]')];
    const slides = [...root.querySelectorAll('[data-media-id]')];
    let activeIndex = Math.max(0, slides.findIndex((slide) => !slide.hidden));

    const showMedia = (id, focusThumb = false) => {
      const nextIndex = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(id));
      if (nextIndex < 0) return;
      slides.forEach((slide, index) => {
        const active = index === nextIndex;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
      });
      thumbs.forEach((thumb) => {
        const active = String(thumb.dataset.mediaTarget) === String(id);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
        if (active) {
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          if (focusThumb) thumb.focus({ preventScroll: true });
        }
      });
      activeIndex = nextIndex;
      const counter = root.querySelector('[data-current-media]');
      if (counter) counter.textContent = String(activeIndex + 1);
    };

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaTarget)));
    root.querySelector('[data-media-prev]')?.addEventListener('click', () => showMedia(slides[(activeIndex - 1 + slides.length) % slides.length].dataset.mediaId, true));
    root.querySelector('[data-media-next]')?.addEventListener('click', () => showMedia(slides[(activeIndex + 1) % slides.length].dataset.mediaId, true));

    const stage = root.querySelector('[data-stage]');
    let touchStart = 0;
    stage?.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0].clientX; }, { passive: true });
    stage?.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(distance) < 45 || slides.length < 2) return;
      const next = distance < 0 ? (activeIndex + 1) % slides.length : (activeIndex - 1 + slides.length) % slides.length;
      showMedia(slides[next].dataset.mediaId);
    }, { passive: true });
    stage?.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const offset = event.key === 'ArrowRight' ? 1 : -1;
      showMedia(slides[(activeIndex + offset + slides.length) % slides.length].dataset.mediaId, true);
    });

    const dialog = root.querySelector('[data-zoom-dialog]');
    root.querySelectorAll('[data-zoom-open]').forEach((button) => button.addEventListener('click', () => {
      const image = button.querySelector('img')?.cloneNode(true);
      const content = root.querySelector('[data-zoom-content]');
      if (!image || !content || !dialog) return;
      content.replaceChildren(image);
      dialog.showModal();
    }));
    root.querySelector('[data-zoom-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });

    const optionInputs = [...root.querySelectorAll('[data-option-input]')];
    const getSelectedOptions = () => [...root.querySelectorAll('.ppi__option')].map((fieldset) => fieldset.querySelector('input:checked')?.value);
    const updateVariant = () => {
      const selected = getSelectedOptions();
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      root.querySelectorAll('.ppi__option').forEach((fieldset) => {
        const output = fieldset.querySelector('[data-selected-option]');
        const checked = fieldset.querySelector('input:checked');
        if (output && checked) output.textContent = checked.value;
      });
      if (!variant) return;
      root.querySelector('[data-variant-id]').value = variant.id;
      root.querySelector('[data-current-price]').textContent = formatMoney(variant.price);
      const compare = root.querySelector('[data-compare-price]');
      const sale = root.querySelector('[data-sale-badge]');
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compare) {
        compare.hidden = !onSale;
        compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      }
      if (sale) sale.hidden = !onSale;
      const addButton = root.querySelector('[data-add-to-cart]');
      const addLabel = root.querySelector('[data-add-label]');
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? addLabel.dataset.available || root.dataset.addLabel || 'Add to cart' : root.dataset.soldOutLabel || 'Sold out';
      const availability = root.querySelector('[data-availability]');
      if (availability) {
        availability.textContent = variant.available ? root.dataset.inStockLabel || 'In stock' : root.dataset.soldOutLabel || 'Sold out';
        availability.classList.toggle('is-in-stock', variant.available);
        availability.classList.toggle('is-out-of-stock', !variant.available);
      }
      const sku = root.querySelector('[data-sku]');
      if (sku) {
        sku.hidden = !variant.sku;
        const value = sku.querySelector('span');
        if (value) value.textContent = variant.sku || '';
      }
      if (variant.featured_media) showMedia(variant.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
    };
    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));

    const quantity = root.querySelector('[data-quantity] input');
    root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
    root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) + 1); });

    root.querySelector('[data-wishlist]')?.addEventListener('click', (event) => {
      const button = event.currentTarget;
      button.setAttribute('aria-pressed', button.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
    });

    form?.addEventListener('submit', async (event) => {
      if (!window.fetch) return;
      event.preventDefault();
      const button = form.querySelector('[data-add-to-cart]');
      const message = form.querySelector('[data-form-message]');
      const original = button.querySelector('[data-add-label]').textContent;
      button.disabled = true;
      button.querySelector('[data-add-label]').textContent = root.dataset.addingLabel || 'Adding…';
      message.textContent = '';
      message.classList.remove('is-success');
      try {
        const cartRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(cartRoot + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const item = await response.json();
        if (!response.ok) throw new Error(item.description || item.message || 'Unable to add this item.');
        message.textContent = root.dataset.addedLabel || 'Added to cart.';
        message.classList.add('is-success');
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { item } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item } }));
      } catch (error) {
        message.textContent = error.message;
      } finally {
        button.disabled = false;
        button.querySelector('[data-add-label]').textContent = original;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
